"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CARD_TYPES = void 0;
exports.CARD_TYPES = {
    default: 'default',
    visa: 'visa',
    mastercard: 'mastercard',
    master: 'mastercard',
    amex: 'american_express',
    american_express: 'american_express',
    discover: 'discover',
    diners_club: 'diners_club',
    dinersclub: 'diners_club',
    jcb: 'jcb',
    dankort: 'dankort',
    maestro: 'maestro',
    carnet: 'carnet',
    elo: 'elo',
    alelo: 'alelo',
    cabal: 'cabal',
    hipercard: 'cabal',
    naranja: 'naranja'
};
